import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { toast, ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Helmet } from 'react-helmet';

import {
  EntityMapperContext,
  I18nProvider,
} from '@uncinc/react-drupal-core';

import { useSelector } from 'react-redux';
import i18next from '../../config/i18next';
import blocksMapper from '../../mappers/blocks';
import nodeMapper from '../../mappers/node';
import paragraphMapper from '../../mappers/paragraphs';
import taxonomyMapper from '../../mappers/taxonomy';
import viewsMapper from '../../mappers/views';
import commentMapper from '../../mappers/comment';
import Routes from '../Routes';
import { Cookie, MessageContainer, Skiplink } from '../../components';
import UserProfileContainer from '../UserProfileContainer';
import useLanguageNegotiator from '../../hooks/useLanguageNegotiator';
import { IS_REACT_NATIVE } from '../../config/constants';

const App = () => {
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Immutable.Map()));
  const rootClasses = useSelector((state) => state.getIn(['ui', 'rootClasses']));
  const language = useSelector((state) => state.getIn(['ui', 'language']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));
  const currentDomain = useSelector((state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], ''));

  toast.configure();

  const classNames = c('App', rootClasses.join(' '), {
    'is-front-page': childEntity.get('is_front'),
    'not-found': !entityExists,
    'is-react-native': IS_REACT_NATIVE,
  });

  const entityTypeMapper = {
    block: blocksMapper,
    node: nodeMapper,
    paragraph: paragraphMapper,
    taxonomy: taxonomyMapper,
    view: viewsMapper,
    comment: commentMapper,
  };

  useLanguageNegotiator();

  return (
    <div data-theme={currentDomain}>
      <EntityMapperContext.Provider value={entityTypeMapper}>
        <I18nProvider locale={language} i18next={i18next}>
          <Helmet>
            <html lang={language} />
          </Helmet>
          <UserProfileContainer>
            <MessageContainer>
              <div
                className={classNames}
                language={language}
              >
                <Skiplink />
                <Routes />
                <ToastContainer icon={false} position="bottom-center" transition={Slide} />
                <Cookie />
              </div>
            </MessageContainer>
          </UserProfileContainer>
        </I18nProvider>
      </EntityMapperContext.Provider>
    </div>
  );
};

export default App;
